import React, { useState } from 'react';
import { Typography, Box, Button, Collapse } from '@mui/material';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Чаршафи с ластик от 100% памук | Ранфорс и памучен сатен | GoToBed',
  description:
    'Чаршафи с ластик от 100% памук – ранфорс и памучен сатен. За стандартни и нестандартни матраци, размери по поръчка. Поръчайте онлайн от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Чаршафи с ластик от 100% памук в голямо разнообразие от размери
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Чаршафи с ластик от 100% памук – ранфорс и памучен сатен
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете чаршафи с ластик от 100% памук – както от класически ранфорс,
          така и от по-фин памучен сатен. Ластикът позволява чаршафът да приляга плътно към матрака
          и да остава стабилно на място по време на сън.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме богато разнообразие от размери за стандартни и нестандартни матраци – с
          популярни варианти като 80/200, 90/200, 100/200, 120/200, 140/200, 160/200, 180/200 и
          200/200, както и матраци с височина до 50 см. Колекцията включва едноцветни модели и
          шарени десени с принт.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да създадете цялостен комплект спално бельо, можете да разгледате и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/kalufki/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи без ластик
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако предпочитате конкретна материя, можете да разгледате и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик памучен сатен
          </Typography>
        </Box>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyCharshafiSLastik />;
}

function SeoBodyCharshafiSLastik() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Чаршафи с ластик от 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Чаршафи с ластик от 100% памук – ранфорс и памучен сатен
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Чаршафите с ластик прилягат плътно към матрака и остават стабилно на място по време на сън,
        което ги прави удобни и практични за ежедневна употреба. В GoToBed предлагаме чаршафи с
        ластик от два основни памучни плата – ранфорс и памучен сатен.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всеки модел се изработва внимателно в България и е съобразен с избраните от клиента размери,
        за да пасне добре дори на нестандартни матраци.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако предпочитате конкретна материя, можете да разгледате и:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи с ластик ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi-s-lastik/1/3/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи с ластик памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршафи с ластик за стандартни и нестандартни размери матраци
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме богато разнообразие от размери, подходящи както за стандартни, така и за
          нестандартни матраци, включително такива с височина до 50 см.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред популярните размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '80/200',
            '90/200',
            '100/200',
            '120/200',
            '140/200',
            '160/200',
            '180/200',
            '200/200'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size} см
            </Typography>
          ))}
        </Box>

        {/* H2: Материи */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Памучни чаршафи с ластик – комфорт и дишаемост
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памукът е предпочитан материал за спално бельо, защото осигурява естествена дишаемост и
          комфорт по време на сън. Предлагаме два основни вида плат:
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е плътен и издръжлив памучен плат, подходящ за ежедневна употреба.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е по-фина и гладка памучна материя с лек естествен блясък и по-меко
          усещане.
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Платовете са сертифицирани по OEKO-TEX Standard 100, което гарантира безопасност и високо
          качество на текстила.
        </Typography>
      </Collapse>

      <Button
        onClick={() => setExpanded(!expanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}
